<template lang="pug">
.generic-wrapper
  .container(v-if="booking && booking.bookingStatusId")

    b-modal(v-model='showReceiveContractModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
      template(#default='props')
        ReceiveContractModal(:booking="booking"
                      @close='props.close'
                      @refreshInbox="refreshBooking()")
    
    b-modal(v-model='showSaveEmailModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
      template(#default='props')
        SaveEmailModal(:booking="booking"
                      @close='props.close'
                      @refreshInbox="refreshBooking()")

    b-modal(v-model='showSendOfferModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
      template(#default='props')
        SendOfferModal(:booking="booking"
                      :rentObject="rentObject"
                      :updatePreviewMode="documentPreviewMode"
                      :bookingInformation="bookingInformation"
                      @refreshInbox="refreshBooking()"
                      @close='props.close')

    b-modal(v-model='showSendContractModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal destroy-on-hide="")
      template(#default='props')
        SendContractModal(:booking="booking"
                      :rentObject="rentObject"
                      :updatePreviewMode="documentPreviewMode"
                      :bookingInformation="bookingInformation"
                      @refreshInbox="refreshBooking()"
                      @close='props.close')

    b-modal(v-model='showPaymentModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
      template(#default='props')
        PaymentModal(:booking="booking"
                      @close='props.close'
                      @refreshInbox="refreshBooking()")

    b-modal(v-model='showSendCancelModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
      template(#default='props')
        SendCancelModal(:booking="booking"
                      @close='props.close'
                      @refreshInbox="refreshBooking()")

    b-modal(v-model='showSendCancelInvoiceModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
      template(#default='props')
        SendCancelInvoiceModal(:booking="booking"
                      @close='props.close'
                      @refreshInbox="refreshBooking()")

    b-modal(v-model='showContractDetails' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
      template(#default='props')
        ShowContractDetailsModal(:bookingId="booking.id"
                      @close='props.close')
    
    BackButton
    .two-side-header
      .left
        template(v-if="id")
          h1.title(@click="showContractDetails = true")
            span(v-if="id && booking.bookingStatus.uuid === 'STATUS_BOOKING_OFFER'") {{`Angebot #${booking.offers[booking.offers.length-1].id} -> `}}
            span(v-if="id && (booking.bookingStatus.uuid === 'STATUS_CONTRACT_SENT' || booking.bookingStatus.uuid === 'STATUS_CONTRACT_RECEIVED')") {{`Mietvertrag #${booking.parentContractId} Version: ${booking.parentContract.contracts.length} -> `}}
            span(v-if="id && booking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED_FINAL'") {{`Stornoabrechnung für Mietvertrag #${booking.parentContractId} Version: ${booking.parentContract.contracts.length} -> `}}
            |{{booking.customer ? `${booking.customer.firstName ? booking.customer.firstName : '' } ${booking.customer.lastName}` : 'Eigenbelegung'}}
          h1.subtitle(v-if="rentObject && rentObject.name") {{rentObject.name}}
          .sub-headline Zuletzt bearbeitet am {{formatDate(booking.updatedAt)}}
        template(v-else)
          h1.title Neuer Vorgang
          h1.subtitle(v-if="rentObject && rentObject.name") {{rentObject.name}}
          .sub-headline Sie können nun einen neuen Vorgang erstellen
        .status
          .status-tag(:style="{'background-color': booking.bookingStatus.colorCode}" @click="changeStatus()") {{booking.bookingStatus.name}}
          .referral {{booking.referral ? `(Quelle: ${booking.referral})` : ''}}
        .spacer.sm
        a(v-if="booking.parentContract && booking.parentContract.contracts[booking.parentContract.contracts.length - 1] && booking.parentContract.contracts[booking.parentContract.contracts.length - 1].digitalSignatureDocumentSrc" :href="booking.parentContract.contracts[booking.parentContract.contracts.length - 1].digitalSignatureDocumentSrc" target="_blank")
            b-button(type="is-primary" size="is-small" iconLeft="file-document-outline") Digital unterschriebenden Vertrag öffnen

      .right(v-if="id && (booking.bookingStatus.uuid === 'STATUS_CONTRACT_SENT' || booking.bookingStatus.uuid === 'STATUS_CONTRACT_RECEIVED' || booking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED' || booking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED_FINAL')")
        .file-upload-button
          b-field
            b-upload(v-model='dropFile' drag-drop='')
              section.section
                .content.has-text-centered
                  p Datei zur Buchung hinzufügen
  
    .tabs-wrapper.margin-top
      b-tabs(type="is-boxed" position="is-centered")
        b-tab-item(label="Buchungsdaten" icon="book-outline")
          .two-column
            .column
              template(v-if="booking.bookingStatus.uuid !== 'STATUS_BOOKING_PERSONAL' && booking.bookingStatus.uuid !== 'STATUS_BOOKING_BLOCKED'")
                h2.title.is-6 Gastdaten
                BookingCustomer(@selectCustomer="(data)=>updateCustomer(data)"
                                @reloadCustomerData="refreshBooking()"
                                @customerDataNeedUpdate="customerDataNeedUpdate = true"
                                @customerDataIsUpdate="customerDataNeedUpdate = false"
                                ref="bookingCustomer"
                                :existingCustomer="booking.customer"
                                :needFullAddress="booking.bookingStatus.uuid === 'STATUS_CONTRACT_SENT'")

                h2.title.is-6 Personen
                .card(:class="{'fully-blocked': customerDataNeedUpdate}")
                  .top
                    b-field(grouped expanded v-if="booking.bookingStatus.uuid !== 'STATUS_BOOKING_BLOCKED'")
                      ValidationProvider(name="Erwachsene" rules="required" v-slot="{ errors, valid }") 
                        b-field(label="Erwachsene" label-position="on-border"
                                :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                          b-select(v-model="booking.adults")
                            option(v-for="a in maxPersonsPlusOne" :value="a-1") {{a-1}} Erwachsene
                      .spacer.sm
                      ValidationProvider(name="Kinder" rules="required" v-slot="{ errors, valid }") 
                        b-field(label="Kinder" label-position="on-border"
                                :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                          b-select(v-model="booking.children")
                            option(v-for="c in maxPersonsPlusOne" :value="c-1") {{c-1}} Kinder
              
              //- .spacer.md

              h2.title.is-6 Reisedaten
              .card(:class="{'fully-blocked': customerDataNeedUpdate}")
                .top
                  ValidationObserver(v-slot="{ handleSubmit }")
                    ValidationProvider(name="Objektname" rules="required" v-slot="{ errors, valid }") 
                      b-field(label="Objektname" label-position="on-border"
                              :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
                        b-select(v-model="booking.rentObjectId" @input="updateBookingObject()")
                          option(v-for="r in rentObjects" :value="r.id") {{r.name}}
                    CalendarSelection(
                          :currentDateOverride="bookingStartMonth"
                          :bookings="bookingsWithoutThisOne"
                          :selected="{startDate, endDate}"
                          @updateStartDate="(newVal)=>updateStartDate(newVal)"
                          @updateEndDate="(newVal)=>updateEndDate(newVal)")

                    // Only for STATUS_BOOKING_OPTION
                    template(v-if="booking.bookingStatus.uuid === 'STATUS_BOOKING_OPTION'")
                      v-date-picker(:value='booking.optionEndDate' @dayclick="d => updateOptionEndDate(d)" :popover="popoverConfig" :min-date='new Date()' :max-date='startDate' :attributes="[{dates: new Date(), highlight: { fillMode: 'outline' }}]")
                        template(v-slot='{ inputValue, inputEvents }')
                          b-field(label="Optionsende" label-position="on-border")
                            input.dt-selection-date(:value='booking.optionEndDate ? formatDate(booking.optionEndDate) : null' v-on='inputEvents')
                          .disclaimer(v-if="booking.optionEndDate") Für <b>{{optionEndDateBlockingTime === 1 ? optionEndDateBlockingTime + ' Tag' : optionEndDateBlockingTime + ' Tage'}}</b> wird dieser Options-Zeitraum auf der Webseite als <b>blockiert</b> angezeigt.
                      .spacer.md
                    
                    b-message(v-if="!bookingAllowed" type="is-danger" :closable="false")
                      |Es gibt einen Konflikt mit einer anderen Buchung. Deshalb können Sie keine Änderungen an dieser Buchung vornehmen.
            
                    b-field(v-else :label="booking.bookingStatus.uuid === 'STATUS_BOOKING_BLOCKED' ? 'Grund für die Sperrung' : 'Anmerkungen vom Gast'" label-position="on-border")
                      b-input(type="textarea" v-model="booking.comment" maxlength="1000" @input="showCommentSaveButton = true")
                      template(v-if="showCommentSaveButton")
                        b-button(type="is-light" @click="updateComment()") Anmerkung speichern
                        .spacer.md
                  template(v-if="settings.referralList")
                    b-field(label="Woher kommt die Buchung?" label-position="on-border" expanded)
                      b-select(v-model="booking.referral" @input="showReferralSaveButton = true" expanded)
                        option(v-if="settings.referralList.search(booking.referral) === -1" :value="booking.referral") {{booking.referral}}
                        option(v-for="referralType in settings.referralList.split(',')" :value="referralType") {{referralType}}
                      template(v-if="showReferralSaveButton")
                        .spacer.sm
                        b-button(type="is-light" @click="updateReferral()") Quelle speichern
                        .spacer.md
            
              
            .column(v-if="booking.bookingStatus.uuid !== 'STATUS_BOOKING_BLOCKED'")
              h2.title.is-6 Preisberechnung
              .price-wrapper(:class="{'fully-blocked': customerDataNeedUpdate}")
                h2.title.is-6 {{booking.rentObject.name}}
                .ot-date {{formatDate(booking.startDate)}} - {{formatDate(booking.endDate)}}
                PriceCalculationTable(
                  ref="priceCalculation"
                  v-if="rentObject && startDate && endDate"
                  :bookingId="this.id ? this.id : 0"
                  :rentObjectId="rentObject.id"
                  :commissions="commissions"
                  :existingCommissionId="booking.commissionId"
                  :contract="booking && booking.parentContract && booking.parentContract.contracts[booking.parentContract.contracts.length - 1]"
                  :cancelInvoice="booking && booking.cancelInvoices && booking.cancelInvoices[booking.cancelInvoices.length - 1]"
                  :startDate="startDate"
                  :endDate="endDate"
                  :persons="personCount"
                  :bookingExtras="bookingExtras"
                  :existingBookingItems="booking.bookingItems"
                  :bookingStatus="booking.bookingStatus"
                  @update="(d) => updatePriceData(d)"
                )
                b-message(v-else type="is-danger" :closable="false")
                  |Sie haben das Mietobjekt gewechselt. Bitte wählen Sie den gewünschten Zeitraum erneut aus.
                template(v-if="id && (booking.bookingStatus.uuid === 'STATUS_CONTRACT_SENT' || booking.bookingStatus.uuid === 'STATUS_CONTRACT_RECEIVED' || booking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED' || booking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED_FINAL')")
                  h2.title.is-6.margin-top Sonderoptionen
                  .card
                    .top
                      .button-wrapper
                        b-checkbox(:value="this.booking.instantPayment" @input="e => updateInstantPayment(e)")
                          | Sofortzahlung (Sofortüberweising, bar, EC-Karte)  
                          b-tooltip(label="Erst wenn ein neuer Mietvertrag erstellt wird, sieht der Gast die Sofortzahlung.")
                            b-icon(icon="information-outline" type="is-gray" size="is-small")
                  h2.title.is-6.margin-top Zahlungsstatus
                  .card
                    .top
                      PaymentInfoWidget(:booking="booking" mode="minimal")
                      h2.title.is-6 Bereits getätigte Zahlungen
                      BookingPayments(v-for="payment in booking.payments" :payment="payment" @updatePayment="refreshBooking()")
                      b-button(type="is-light" @click="showPaymentModal = true") Neue Zahlung hinzufügen

          .button-wrapper.margin-top.right(v-if="bookingAllowed && !customerDataNeedUpdate")
            b-button(type="is-gray" @click="goBackToCalendar()") Zurück

            // STATUS_BOOKING_INTERNET
            template(v-if="booking.bookingStatus.uuid === 'STATUS_BOOKING_INTERNET'")
              template(v-if="id")
                b-button(type="is-dark" @click="updateOffer()") Angebot erstellen
                .spacer.sm.inline
                b-button(type="is-success" @click="updateContract()") Mietvertrag erstellen

            // STATUS_BOOKING_OFFER
            template(v-else-if="booking.bookingStatus.uuid === 'STATUS_BOOKING_OFFER'")
              template(v-if="id")
                b-button(type="is-primary" @click="updateOffer()" :disabled="!startDate || !endDate") Angebot aktualisieren
                b-button(type="is-success" @click="updateContract()") Mietvertrag erstellen

            // STATUS_BOOKING_OPTION
            template(v-else-if="id && booking.bookingStatus.uuid === 'STATUS_BOOKING_OPTION'")
              template(v-if="id")
                b-button(type="is-primary" @click="updateBooking()" :disabled="!startDate || !endDate") Option aktualisieren
                b-button(type="is-success" @click="updateContract()") Mietvertrag erstellen
                b-message(v-if="booking.bookingStatus.uuid === 'STATUS_BOOKING_OPTION' && booking.optionEndDate === null" type="is-danger") Bei einer Option muss zwingend ein Optionsende eingegeben werden.
            
            // STATUS_CONTRACT_SENT
            template(v-else-if="booking.bookingStatus.uuid === 'STATUS_CONTRACT_SENT'")
              template(v-if="id")
                b-button(type="is-primary" @click="updateContract()" :disabled="!startDate || !endDate") Mietvertrag aktualisieren
                b-button(type="is-success" @click="showReceiveContractModal = true") Mietvertrag zurück bekommen
              template(v-else)
                b-button(type="is-primary" @click="createBooking('onlyContract')" :disabled="!startDate || !endDate") Mietvertrag erstellen
                b-button(type="is-success" @click="createBooking('emailContract')" :disabled="!startDate || !endDate") Mietvertrag mit Vorschau erstellen
            
            // STATUS_CONTRACT_RECEIVED
            template(v-else-if="booking.bookingStatus.uuid === 'STATUS_CONTRACT_RECEIVED'")
              template(v-if="id")
                b-button(type="is-primary" @click="updateContract()" :disabled="!startDate || !endDate") Mietvertrag aktualisieren
            
            // Everything else
            template(v-else)
              b-button(v-if="id" type="is-primary" @click="updateBooking('back')" :disabled="!startDate || !endDate || (booking.bookingStatus.uuid === 'STATUS_BOOKING_OPTION' && booking.optionEndDate === null)") Aktualisieren
              b-button(v-else type="is-primary" @click="createBooking()" :disabled="!startDate || !endDate || (booking.bookingStatus.uuid === 'STATUS_BOOKING_OPTION' && booking.optionEndDate === null)") Speichern
              b-message(v-if="booking.bookingStatus.uuid === 'STATUS_BOOKING_OPTION' && booking.optionEndDate === null" type="is-danger") Bei einer Option muss zwingend ein Optionsende eingegeben werden.

          .button-wrapper.margin-top.right(v-if="!customerDataNeedUpdate")
            // STATUS_BOOKING_CANCELED
            template(v-if="booking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED' || booking.bookingStatus.uuid === 'STATUS_BOOKING_CANCELED_FINAL'")
              template(v-if="id")
                b-button(type="is-primary" @click="showSendCancelInvoiceModal = true" :disabled="!startDate || !endDate") Stornorechnung erstellen

        b-tab-item(:label="id ? `Verlauf #${booking.id}` : 'Verlauf'" icon="history" :disabled="booking.bookingStatus.uuid === 'STATUS_BOOKING_BLOCKED' || !this.id")
          BookingManagement(v-if="id && booking" :booking="booking" @refreshBooking="refreshBooking()")
</template>

<script>
import {DateTime} from "luxon"
import BackButton from '@/components/atoms/BackButton'
import PaymentInfoWidget from '@/components/atoms/PaymentInfoWidget'
import CalendarSelection from '@/components/molecules/CalendarSelection'
import BookingSelectExtraModal from '@/components/molecules/BookingSelectExtraModal'
import CustomerModal from '@/components/molecules/CustomerModal'
import BookingCustomer from '@/components/molecules/BookingCustomer'
import BookingManagement from '@/components/organisms/BookingManagement'
import ReceiveContractModal from "@/components/molecules/ReceiveContractModal.vue";
import PriceCalculationTable from "@/components/molecules/PriceCalculationTable.vue";
import SaveEmailModal from "@/components/molecules/SaveEmailModal.vue";
import SendOfferModal from "@/components/molecules/SendOfferModal.vue";
import SendContractModal from "@/components/molecules/SendContractModal.vue";
import ShowContractDetailsModal from "@/components/molecules/ShowContractDetailsModal.vue";
import PaymentModal from "@/components/molecules/PaymentModal.vue";
import SendCancelModal from "@/components/molecules/SendCancelModal.vue";
import SendCancelInvoiceModal from "@/components/molecules/SendCancelInvoiceModal.vue";
import BookingPayments from "@/components/molecules/BookingPayments.vue";

export default {
  components: {
    BackButton,
    PaymentInfoWidget,
    CalendarSelection,
    BookingSelectExtraModal,
    CustomerModal,
    BookingManagement,
    ReceiveContractModal,
    BookingCustomer,
    PriceCalculationTable,
    SaveEmailModal,
    SendOfferModal,
    SendContractModal,
    PaymentModal,
    SendCancelModal,
    SendCancelInvoiceModal,
    BookingPayments,
    ShowContractDetailsModal
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      settings: {},
      customerDataNeedUpdate: false,
      bookingAllowed: true,
      // Modal related
      showReceiveContractModal: false,
      showSaveEmailModal: false,
      showSendOfferModal: false,
      showSendContractModal: false,
      showPaymentModal: false,
      showSendCancelModal: false,
      showSendCancelInvoiceModal: false,
      showCustomerModal: false,
      showCommentSaveButton: false,
      showReferralSaveButton: false,
      showContractDetails: false,
      // Booking related
      booking: null,
      rentObject: null,
      startDate: null,
      endDate: null,
      commissions: null,
      bookingInformation: {
        items: {
          priceItems: [],
          bookingExtraItems: undefined
        },
        verifyTotal: null
      },
      bookingStartMonth: null,
      documentPreviewMode: false,
      dropFile: null,
      popoverConfig: {
        visibility: 'focus'
      }
    };
  },
  computed: {
    optionEndDateBlockingTime() {
      if (!this.booking.optionEndDate) return;
      return Math.floor(DateTime.fromISO(this.booking.optionEndDate).diff(DateTime.local(), 'days').toObject().days);
    },
    maxPersonsPlusOne() {
      if (!this.rentObject || !this.rentObject.persons) return 20;
      return this.rentObject.persons + 2;
    },
    rentObjects() {
      return this.$store.state.rentObjects.all.filter(r => r.rentObjectType.isBookable);
    },
    bookingStatus() {
      return this.$store.state.bookingStatus.all;
    },
    bookingsWithoutThisOne() {
      if (!this.rentObject) return []

      const contractSendStatus = this.bookingStatus.find(b => b.uuid === 'STATUS_CONTRACT_SENT');
      const contractReceivedStatus = this.bookingStatus.find(b => b.uuid === 'STATUS_CONTRACT_RECEIVED');
      const optionStatus = this.bookingStatus.find(b => b.uuid === 'STATUS_BOOKING_OPTION');
      const ownerStatus = this.bookingStatus.find(b => b.uuid === 'STATUS_BOOKING_PERSONAL');
      const blockedStatus = this.bookingStatus.find(b => b.uuid === 'STATUS_BOOKING_BLOCKED');
      const cancelStatus = this.bookingStatus.find(b => b.uuid === 'STATUS_BOOKING_CANCELED');
      const cancelInvoiceStatus = this.bookingStatus.find(b => b.uuid === 'STATUS_BOOKING_CANCELED_FINAL');
      if ([cancelStatus.id, cancelInvoiceStatus.id].includes(this.booking.bookingStatusId)) {
        return []
      }

      return this.rentObject.rentObjectBookings.filter(b=>b.id !== this.booking.id && [contractSendStatus.id, contractReceivedStatus.id, optionStatus.id, ownerStatus.id, blockedStatus.id].includes(b.bookingStatusId))
    },
    bookingExtras() {
      return this.$store.state.bookingExtras.all;
    },
    nightCount() {
      if (!this.booking && !this.booking.bookingItems) return 0;
      let nights = 0;
      for (let i = 0; i < this.booking.bookingItems.length; i += 1) {
        if (this.booking.bookingItems[i].referenceColumnName === "rentObjectPrices") {
          nights += this.booking.bookingItems[i].count
        }
      }
      return nights;
    },
    personCount() {
      if (!this.booking) return 0;
      return this.booking.adults + this.booking.children;
    },
  },
  watch: {
    dropFile(newVal) {
      this.saveFile(newVal);
    },
    endDate() {
      if (!this.startDate || !this.endDate) return;
      this.booking = {...this.booking, startDate: this.startDate.startOf('day').set({ hour: 15 }).toISO(), endDate: this.endDate.startOf('day').set({ hour: 10 }).toISO()}
    }
  },
  async mounted() {
    this.mountBooking();
    this.settings = await this.$store.dispatch("settings/find");
  },
  methods: {
    async updateComment() {
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("rentObjectBookings/updateComment", {id: this.booking.id, comment: this.booking.comment});
      this.showCommentSaveButton = false;
      loadingComponent.close();
    },
    async updateReferral() {
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("rentObjectBookings/updateReferral", {id: this.booking.id, referral: this.booking.referral});
      this.showReferralSaveButton = false;
      loadingComponent.close();
    },
    async updateInstantPayment(val) {
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("rentObjectBookings/updateInstantPayment", {id: this.booking.id, instantPayment: val});
      loadingComponent.close();
      this.mountBooking();
    },
    async saveFile(data) {
      await this.$store.dispatch("rentObjectBookingAttachments/create", {rentObjectBookingId: this.booking.id, file: data});
      this.booking = await this.$store.dispatch("rentObjectBookings/findOne", {id: this.id});
    },
    goBackToCalendar() {
      this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.startDate).toHTTP(), jumpObjectId: this.rentObject.id, bookingStatusId: this.booking.bookingStatusId}});
    },
    updateStartDate(newVal) {
      this.startDate = newVal.set({ hour: 15 });
    },
    updateEndDate(newVal) {
      if (newVal) {
        this.endDate = newVal.set({ hour: 10 });
      } else {
        this.endDate = newVal;
      }
    },
    updateOptionEndDate(newVal) {
      const optionEndDate = DateTime.fromJSDate(newVal.date).set({hour: 23, minute: 59});
      this.booking.optionEndDate = optionEndDate.toISO();
    },
    async mountBooking(showContract) {
      this.customerDataNeedUpdate = false;
      this.startDate = null;
      this.endDate = null;
      this.booking = null;
      this.bookingInformation = {
        items: {
          priceItems: [],
          bookingExtraItems: []
        },
        verifyTotal: null
      };
      const loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("bookingExtras/findAll");
      await this.$store.dispatch("rentObjects/findAll");
      await this.$store.dispatch("bookingStatus/findAll");
      this.commissions = await this.$store.dispatch("commissions/findAll");

      if (this.id) {
        await this.$store.dispatch("rentObjectBookings/findOne", {id: this.id});
        this.booking = JSON.parse(JSON.stringify(this.$store.state.rentObjectBookings.single));
        this.rentObject = await this.$store.dispatch("rentObjects/findOne", { id: this.booking.rentObjectId });
        this.booking.rentObject = this.rentObject;
        this.startDate = DateTime.fromISO(this.booking.startDate);
        this.endDate = DateTime.fromISO(this.booking.endDate);

        // The calendar should be in focus
        this.bookingStartMonth = DateTime.local(this.startDate.year, this.startDate.month);

        // When Internet Booking and first booking we trigger the contracz modal right away to safe some time
        if (showContract && this.booking.bookingStatus.uuid === 'STATUS_BOOKING_INTERNET') {
          this.showSendContractModal = true;
        }
      } else {
        // This means we want to create a new booking
        this.rentObject = await this.$store.dispatch("rentObjects/findOne", { id: this.$route.query['rent-object-id'] });
        const status = this.bookingStatus.find(b => b.uuid === this.$route.query.status)
        
        // here we select the commission
        let commission;
        if (status.uuid !== 'STATUS_BOOKING_OWNER') {
          commission = this.commissions.find(c => c.uuid === 'COMMISSION_STANDARD');
        } else {
          commission = this.commissions.find(c => c.uuid === 'COMMISSION_OWNER');
        }

        this.booking = {
          rentObjectId: this.rentObject.id,
          rentObject: this.rentObject,
          bookingStatusId: status.id,
          bookingStatus: status,
          optionEndDate: null,
          createdAt: new Date(),
          bookingItems: [],
          adults: 1,
          children: 0,
          verifyTotal: null,
          commissionId: commission.id
        }
        this.startDate = DateTime.fromHTTP(this.$route.query.start).startOf('day').set({ hour: 15 });
        this.endDate = DateTime.fromHTTP(this.$route.query.end).startOf('day').set({ hour: 10 });
        // The calendar should be in focus
        this.bookingStartMonth = DateTime.local(this.startDate.year, this.startDate.month);
      }

      if (this.$route.query.showContract) {
        // here we load the temporary saved data
          if (this.$store.state.rentObjectBookings.temporaryBooking) {
            this.booking = {...this.booking, ...this.$store.state.rentObjectBookings.temporaryBooking.booking, customer: this.booking.customer};
            this.bookingInformation = {...this.bookingInformation, ...this.$store.state.rentObjectBookings.temporaryBooking.bookingInformation};
            this.booking.bookingItems = this.bookingInformation.items.priceItems.concat(this.bookingInformation.items.bookingExtraItems);
            this.$nextTick(() => {
              this.$refs.priceCalculation.updateCalculation("", () => this.updateContract());
            });
          }
      }
      loadingComponent.close();
    },
    async refreshBooking() {
      this.$nextTick(async () => {
        this.mountBooking();
      });
    },
    updateOffer() {
      this.documentPreviewMode = true;
      this.showSendOfferModal = true;
    },
    updateContract() {
      this.documentPreviewMode = true;
      this.showSendContractModal = true;
    },
    async updateBooking(back) {
      // This means nothing changed
      if (!this.startDate) return;

      const loadingComponent = this.$buefy.loading.open();
      this.booking = {...this.booking, startDate: this.startDate.startOf('day').set({ hour: 15 }).toISO(), endDate: this.endDate.startOf('day').set({ hour: 10 }).toISO()}
      for (let i = 0; i < this.booking.bookingItems.length; i += 1) {
        this.booking.bookingItems[i].id = undefined;
      }
      await this.$store.dispatch("rentObjectBookings/update", {...this.booking, ...this.bookingInformation.items, verifyTotal: this.bookingInformation.verifyTotal});
      
      if (back) this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.booking.startDate).toHTTP(), jumpObjectId: this.booking.rentObjectId}});
      loadingComponent.close();
    },
    async createBooking(contractMode) {
      this.booking = {...this.booking, startDate: this.startDate.startOf('day').set({ hour: 15 }).toISO(), endDate: this.endDate.startOf('day').set({ hour: 10 }).toISO()}
      for (let i = 0; i < this.booking.bookingItems.length; i += 1) {
        this.booking.bookingItems[i].id = undefined;
      }
      
      // First we check if a customer is selected
      let loadingComponent = this.$buefy.loading.open();
      if (this.$refs.bookingCustomer) {
        this.$refs.bookingCustomer.createCustomer(async () => {
          if (this.booking.customer) {
            // Now we check if we want to send a contract
            // for a contract we need the full name and address
            if (this.booking.bookingStatus.uuid === 'STATUS_CONTRACT_SENT') {
              if (!this.booking.customer.firstName || !this.booking.customer.lastName || !this.booking.customer.address.street || !this.booking.customer.address.zip || !this.booking.customer.address.city) {
                this.$buefy.dialog.alert({
                  title: 'Gastdaten sind unvollständig',
                  message: 'Damit ein Mietvertrag erstellt werden kann, müssen alle Gastdaten eingegeben werden',
                  type: 'is-warning',
                  ariaRole: 'alertdialog',
                  ariaModal: true
                })
                return;
              }
              if (contractMode === 'onlyContract') {
                let loadingComponent = this.$buefy.loading.open();
                let formData = {};
                const emailTemplates = await this.$store.dispatch("emailTemplates/findAll");
                let contractTemplate = emailTemplates.find(e => e.uuid === 'CONTRACT_EMAIL');
                const result = await this.$store.dispatch("emailTemplates/replaceTemplateValues", {template: contractTemplate, booking: this.booking});
                formData.subject = result.template.subject;
                formData.body = result.template.body;
                const newBooking = await this.$store.dispatch("rentObjectBookings/create", {...this.booking, ...this.bookingInformation.items, verifyTotal: this.bookingInformation.verifyTotal});
                await this.$store.dispatch("contracts/create", {...formData, rentObjectBookingId: newBooking.id});
                loadingComponent.close();
                this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.booking.startDate).toHTTP(), jumpObjectId: this.booking.rentObjectId}});
              } else {
                loadingComponent.close();
                this.showSendContractModal = true;
              }
            } else {
              await this.$store.dispatch("rentObjectBookings/create", {...this.booking, ...this.bookingInformation.items, verifyTotal: this.bookingInformation.verifyTotal});
              this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.booking.startDate).toHTTP(), jumpObjectId: this.booking.rentObjectId}});
              loadingComponent.close();
            }
          } else {
            this.$buefy.dialog.alert({
              title: 'Gast fehlt',
              message: 'Sie müssen einen Gast auswählen.',
              type: 'is-warning',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        });
      } else {
        // Here we create a new booking
        await this.$store.dispatch("rentObjectBookings/create", {...this.booking, ...this.bookingInformation.items, verifyTotal: this.bookingInformation.verifyTotal});
        this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(this.booking.startDate).toHTTP(), jumpObjectId: this.booking.rentObjectId}});
      }

      loadingComponent.close();
    },
    // async updateBookingStatus(uuid) {
    //   const status = this.bookingStatus.find(b => b.uuid === uuid);
    //   await this.$store.dispatch("rentObjectBookings/updateBookingStatus", {id: this.booking.id, bookingStatusId: status.id});
    //   await this.$store.dispatch("rentObjectBookings/findOne", {id: this.id});
    //   this.booking = JSON.parse(JSON.stringify(this.$store.state.rentObjectBookings.single));
    // },
    async updateCustomer(data) {
      this.$set(this.booking, "customer", data);
      this.$set(this.booking, "customerId", data.id);
      // only if existing booking we update the booking
      if (this.id) {
        await this.$store.dispatch("rentObjectBookings/updateCustomer", {id: this.id, customerId: data.id});
      }
    },
    sanitizeNumber(nbr) {
      // So that nobody can type in weired data
      if (!parseInt(nbr)) return 0
      if (nbr.length <= 0) return 0
      return parseInt(nbr)
    },
    async updateBookingObject() {
      
      if (this.booking.bookingStatus.uuid === 'STATUS_BOOKING_BLOCKED') {
        const loadingComponent = this.$buefy.loading.open();
        this.rentObject = await this.$store.dispatch("rentObjects/findOne", { id: this.booking.rentObjectId });
        this.booking.rentObject = this.rentObject;
        loadingComponent.close();
        return;
      }

      this.$nextTick(async function () {
        this.$buefy.dialog.confirm({
          title: "Objektwechsel",
          message: `Möchten Sie alle Extras und womögliche Sonderanpassungen in das neue Objekt mit übernehmen?`,
          confirmText: `Ja, bitte übernehmen`,
          cancelText: "Nein, nicht übernehmen",
          type: "is-success",
          hasIcon: true,
          onConfirm: async () => {
            try {
              const loadingComponent = this.$buefy.loading.open();
              this.rentObject = await this.$store.dispatch("rentObjects/findOne", { id: this.booking.rentObjectId });
              this.booking.rentObject = this.rentObject;
              this.$refs.priceCalculation.updateCalculation();
              loadingComponent.close();
            } catch (e) {
              // todo
            }
          },
          onCancel: async () => {
            try {
              const loadingComponent = this.$buefy.loading.open();
              this.rentObject = await this.$store.dispatch("rentObjects/findOne", { id: this.booking.rentObjectId });
              this.booking.rentObject = this.rentObject;
              this.$refs.priceCalculation.updateCalculation('newExtras');
              loadingComponent.close();
            } catch (e) {
              // todo
            }
          },
        });
      });
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
    toggleCustomerModal() {
      this.showCustomerModal = !this.showCustomerModal;
    },
    removeBookingExtra(idx) {
      this.booking.bookingItems.splice(idx, 1);
    },
    updatePriceData (data) {
      this.bookingInformation.items = {...data};
      this.bookingInformation.verifyTotal = data.total;
      this.bookingAllowed = data.bookingAllowed;
    }
  }
}
</script>

<style lang="scss" scoped>
.status {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.status-tag {
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 12px;
  display: inline-block;
  font-weight: 500;
  margin-right: $sm-space;
}
.button-wrapper {
  margin: $xs-space 0 $sm-space 0;
}
.two-column {
  display: flex;
  justify-content: space-between;
}
.label {
  font-weight: 600;
  margin-top: $sm-space;
  margin-bottom: 0;
  &:not(:last-child) {
    margin-bottom: 0;
  }
}
.total-sum-wrapper {
  text-align: right;
  display: flex;
  justify-content: space-between;
  .total {
    font-weight: bold;
    border-bottom: double 3px;
  }
}
.two-side-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

.disclaimer {
  font-size: 0.8rem;
}
.file-upload-button {
  opacity: 0.4;
  margin-right: $sm-space;
  p {
    font-size: 12px;
  }
}
.price-wrapper {
  h2 {
    margin: $sm-space 0 $xs-space 0;
  }
  .ot-date {
    margin: 0 0 $sm-space 0;
  }
}
.dt-selection-date {
  padding: 4px 8px;
  border-radius: 3px;
  border: solid 1px $lightgray;
  font-size: 1rem;
  font-weight: 500;
}
.referral {
  color: $darkgray;
  font-size: 12px;
}
</style>